import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { ContentDataTable } from "src/components/Common/ContentDataTable";
import { SectionNoData } from "src/components/Common/SectionNoData";
import { IConfig, IEventNotification } from "src/services/types";
import { toast } from 'react-toastify';
import { SearchTable } from "src/components/Common/SearchTable";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import { GroupModal } from "../UsersToValidate/GroupModal";
import { NoteModal } from "../UsersToValidate/NoteModal";
import { DetailsUserModal } from "../Users/DetailsUserModal";
import { getEventsNotification, updateEventNotification } from "src/services/event-notification-service";
import { columnsNotifications } from "./ColumnsNotifications";
import { EventTypeFilter } from "./EventTypeFilter";
import { ConfirmReturnToReviewModal } from "../RejectedUsers/ConfirmReturnToReviewModal";
import { ConfirmRejectModal } from "../UsersToValidate/ConfirmRejectModal";
import { ConfirmValidateModal } from "../UsersToValidate/ConfirmValidateModal";
import { IndicatorsEventNotifications } from "./IndicatorsEventNotifications";

export const Notifications = () => {
    document.title = "Secure | Event Notifications";

  const [totalRows, setTotalRows] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [eventNotifications, setEventNotifications] = useState<IEventNotification[]>([]);
  const [eventNotificationSelected, setEventNotificationSelected] = useState<IEventNotification | null>(null);
  const [showUserDetailModal, setShowUserDetailModal] = useState(false);
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [showMoveToGroupModal, setShowMoveToGroupModal] = useState(false);
  const [showReturnToReviewModal, setShowReturnToReviewModal] = useState(false);
  const [showRejectedModal, setShowRejectedModal] = useState(false);
  const [showValidateModal, setShowValidateModal] = useState(false);

  const [config, setConfig] = useState<IConfig>({
      page: 1,
      per_page: 20,
      search: "",
      read_status: 1, // 1 for unread
  });

  const fetchData = async (config: IConfig) => {
    setIsLoading(true);
    const res = await getEventsNotification(config)
    setIsLoading(false);
    if (res.result === 'ok') {
        setTotalRows(res?.data?.pagination?.total);
        setEventNotifications(res.data.data);
        
    } else {
        console.log('error:', res.message);
        toast(res.message, { type: 'error'});
    }
  }

  const openModal = async (item: IEventNotification, usersAux: IEventNotification[] = [] ) => {
    setEventNotificationSelected(item);
    setShowUserDetailModal(true);
  }

  const openNoteModal = async (item: IEventNotification) => {
    setEventNotificationSelected(item);
    setShowNoteModal(true);
  }

  const onMoveAGroup = async (item: IEventNotification) => {
    setEventNotificationSelected(item);
    setShowMoveToGroupModal(true);
  }

  const refresh = () => {
    fetchData(config);
  }

  const handleChangeEventType = (id: string) => {
    setConfig({ ...config, event_type: id, page: 1 });
  }

  const onMarkAsRead = async (item: IEventNotification) => {
    if (isLoading) return; // Prevent multiple clicks while loading
    setIsLoading(true);
    const res = await updateEventNotification(item.id);
    setIsLoading(false);
    if (res.result === 'ok') {
        toast('Event notification marked as read', { type: 'success' });
        fetchData(config);
    } else {
        toast(res.message, { type: 'error' });
    }
  }

  const onReturnToReview = async (item: IEventNotification) => {
    setEventNotificationSelected(item);
    setShowReturnToReviewModal(true);
  }

  const onValidate = async (item: IEventNotification) => {
    setEventNotificationSelected(item);
    setShowValidateModal(true);
  }

  const onReject = async (item: IEventNotification) => {
    setEventNotificationSelected(item);
    setShowRejectedModal(true);
  }

  const refreshData = () => {
    refresh();
    setForceRefresh(true); // Toggle to force refresh
  }

  useEffect(() => {
    fetchData(config);
  }, [config]);

  const [forceRefresh, setForceRefresh] = useState(false);

  return (
    <>
      <div className="page-content">
          <h2 className="text-primary">Event Notifications</h2>
          <IndicatorsEventNotifications onRefresh={refresh} setForceRefresh={() => setForceRefresh(false)} forceRefresh={forceRefresh} />
          <Card>
            {/* <div className="m-2 text-muted">Filters</div> */}
            <CardBody className="">
              <Row className="gap-3">
                <Col sm={6} className="" >
                  <div>Filter by Status:</div>
                  <div className="border rounded d-flex gap-3 p-2" >
                    <Button
                        color={config?.read_status == 1 ? "info" : "soft-info"}
                        onClick={() => setConfig({ ...config, read_status: 1, page: 1 })}
                        style={{ width: '100px' }}
                    >
                        <span className='d-flex align-items-center'>
                          Unread
                        </span>
                    </Button>
                    <Button
                        color={config?.read_status == 2 ? "info" : "soft-info"}
                        onClick={() => setConfig({ ...config, read_status: 2, page: 1 })}
                        style={{ width: '100px' }}
                    >
                        <span className='d-flex align-items-center'>
                          Read  
                        </span>
                    </Button>
                    <Button
                        color={config?.read_status == 3 ? "info" : "soft-info"}
                        onClick={() => setConfig({ ...config, read_status: 3, page: 1 })}
                        style={{ width: '100px' }}
                    >
                        <span className='d-flex align-items-center'>
                          <span className='ms-2'>All</span>
                        </span>
                    </Button>
                  </div>
                </Col>
                <Col sm={3} className="d-flex align-items-center justify-content-start">
                  <EventTypeFilter
                    onChange={handleChangeEventType}
                    label="Filter by Event Type"
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Row className="mb-2">
              <Col sm={6} className="d-flex align-items-end justify-content-start gap-2">
                <div>
                    <button
                      type="button"
                      className="btn btn-soft-primary waves-effect waves-light"
                      onClick={refreshData}
                    >
                        <i className="fas fa-sync-alt"></i> Refresh
                    </button>
                </div>
                </Col>
              <Col sm={6} className="d-flex justify-content-end align-items-end" >
                  <div className="w-75">
                    <SearchTable 
                      onSearch={(search) => setConfig({ ...config, search, page: 1 })}
                      loading={isLoading && !!config.search}
                      placeholder="Search by User Name ..."
                    />
                  </div>
              </Col>
          </Row>
         
          <ContentDataTable isLoading={isLoading}>
              <DataTable
                customStyles={{
                    rows: { style: { minHeight: '50px' }},
                    table: { style: { minHeight: '400px'}},
                    cells: { style: { paddingLeft: '8px', paddingRight: '8px' }},
                }}
                columns={
                  columnsNotifications(
                    config, 
                    openModal, 
                    onValidate, 
                    onReject, 
                    onMoveAGroup, 
                    openNoteModal, 
                    onMarkAsRead,
                    onReturnToReview
                  )
                  }
                data={eventNotifications}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                responsive
                onChangeRowsPerPage={(per_page) => setConfig({ ...config, per_page, page: 1 })}
                onChangePage={(page) => setConfig({ ...config, page })}
                paginationDefaultPage={config.page}
                paginationPerPage={config.per_page}
                paginationRowsPerPageOptions={[10, 20, 50, 100]}
                noDataComponent={
                    <SectionNoData
                        onRefresh={() => fetchData(config)}
                        isLoading={isLoading}
                    />
                }
              />
          </ContentDataTable>
      </div>

        <DetailsUserModal
            isViewUser
            show={showUserDetailModal}
            onClose={() => (setEventNotificationSelected(null), setShowUserDetailModal(false))}
            userId={eventNotificationSelected?.user_id!}
        />

        <GroupModal 
            show={showMoveToGroupModal}
            onClose={() => setShowMoveToGroupModal(false)}
            onRefresh={refresh}
            item={eventNotificationSelected?.user!}
        />

        <NoteModal 
            show={showNoteModal}
            onClose={() => setShowNoteModal(false)}
            onRefresh={refresh}
            item={eventNotificationSelected?.user!}
        />

        <ConfirmValidateModal
            show={showValidateModal}
            onClose={() => setShowValidateModal(false)}
            onRefresh={refresh}
            user={eventNotificationSelected?.user!}
        />

        <ConfirmRejectModal
            show={showRejectedModal}
            onClose={() => setShowRejectedModal(false)}
            onRefresh={refresh}
            user={eventNotificationSelected?.user!}
        />

        <ConfirmReturnToReviewModal
            show={showReturnToReviewModal}
            onClose={() => setShowReturnToReviewModal(false)}
            onRefresh={refresh}
            user={eventNotificationSelected?.user!}
        />

    </>
  )
}
